import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Avatar, Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Stack, Tooltip, Typography, } from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import ContrastIcon from "@mui/icons-material/ContrastOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { getAdminRole, removeTokens } from "../utils/auth";
import { useColorMode } from "../theme/ColorModeProvider";
import { getSectionPath } from "./Sidebar";
import { TOPBAR_HEIGHT } from "../theme/theme";
const ROLE_LABELS = {
    admin: "Администратор",
    "recipe-manager": "Контент-менеджер",
};
const MODE_OPTIONS = [
    { value: "light", label: "Светлая" },
    { value: "dark", label: "Тёмная" },
    { value: "system", label: "Как в системе" },
];
const TopBar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { preference, mode, setPreference } = useColorMode();
    const [themeAnchor, setThemeAnchor] = useState(null);
    const [userAnchor, setUserAnchor] = useState(null);
    const role = getAdminRole();
    const roleLabel = role === null ? "Администратор" : (ROLE_LABELS[role] ?? role);
    const section = getSectionPath(location.pathname);
    const handleLogout = () => {
        removeTokens();
        setUserAnchor(null);
        navigate("/login", { replace: true });
    };
    return (_jsxs(Box, { component: "header", sx: {
            height: TOPBAR_HEIGHT,
            flex: "none",
            px: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: "background.paper",
            position: "sticky",
            top: 0,
            zIndex: 10,
        }, children: [_jsx(Stack, { direction: "row", spacing: 0.75, alignItems: "center", sx: { minWidth: 0 }, children: section.map((part, index) => (_jsxs(React.Fragment, { children: [index > 0 && (_jsx(Typography, { variant: "body2", color: "text.disabled", children: "/" })), _jsx(Typography, { variant: "body2", noWrap: true, sx: {
                                color: index === section.length - 1
                                    ? "text.primary"
                                    : "text.secondary",
                                fontWeight: index === section.length - 1 ? 700 : 500,
                            }, children: part })] }, part))) }), _jsxs(Stack, { direction: "row", spacing: 1, alignItems: "center", children: [_jsx(Tooltip, { title: "\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435", children: _jsx(IconButton, { onClick: (event) => {
                                setThemeAnchor(event.currentTarget);
                            }, children: mode === "dark" ? (_jsx(DarkModeIcon, { fontSize: "small" })) : (_jsx(LightModeIcon, { fontSize: "small" })) }) }), _jsx(Menu, { anchorEl: themeAnchor, open: themeAnchor !== null, onClose: () => {
                            setThemeAnchor(null);
                        }, children: MODE_OPTIONS.map((option) => (_jsxs(MenuItem, { selected: option.value === preference, onClick: () => {
                                setPreference(option.value);
                                setThemeAnchor(null);
                            }, children: [_jsxs(ListItemIcon, { children: [option.value === "light" && _jsx(LightModeIcon, { fontSize: "small" }), option.value === "dark" && _jsx(DarkModeIcon, { fontSize: "small" }), option.value === "system" && _jsx(ContrastIcon, { fontSize: "small" })] }), option.label] }, option.value))) }), _jsxs(Box, { onClick: (event) => {
                            setUserAnchor(event.currentTarget);
                        }, sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            pl: 1,
                            pr: 1.5,
                            py: 0.5,
                            borderRadius: 999,
                            cursor: "pointer",
                            "&:hover": { bgcolor: "action.hover" },
                        }, children: [_jsx(Avatar, { sx: {
                                    width: 28,
                                    height: 28,
                                    fontSize: 13,
                                    fontWeight: 700,
                                    bgcolor: "primary.light",
                                    color: "primary.main",
                                }, children: roleLabel.slice(0, 1).toUpperCase() }), _jsx(Typography, { variant: "body2", sx: { fontWeight: 600 }, children: roleLabel })] }), _jsxs(Menu, { anchorEl: userAnchor, open: userAnchor !== null, onClose: () => {
                            setUserAnchor(null);
                        }, children: [_jsxs(Box, { sx: { px: 2, py: 1 }, children: [_jsx(Typography, { variant: "body2", sx: { fontWeight: 700 }, children: roleLabel }), _jsx(Typography, { variant: "caption", color: "text.secondary", children: "\u0410\u0434\u043C\u0438\u043D-\u043F\u0430\u043D\u0435\u043B\u044C FoodLabs" })] }), _jsx(Divider, {}), _jsxs(MenuItem, { onClick: handleLogout, children: [_jsx(ListItemIcon, { children: _jsx(LogoutIcon, { fontSize: "small" }) }), "\u0412\u044B\u0439\u0442\u0438"] })] })] })] }));
};
export default TopBar;
